import React from 'react';

export interface CloseIconProps {
  /** Taille du carré (largeur = hauteur), en pixels. */
  size?: number;
  className?: string;
}

/**
 * Icône de fermeture (×) en SVG inline. Utilise `fill="currentColor"` afin
 * d'hériter automatiquement de la couleur de texte du bouton parent (ex.
 * `color: var(--ctn-close-color)`), sans nécessiter de filtre CSS.
 */
export const CloseIcon: React.FC<CloseIconProps> = ({ size = 16, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 150"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M14.63,24.93c27.74,44.37,73.98,71.01,106.6,111.04,3.07,3.77,9.54,3.19,12.73,0,3.73-3.73,3.08-8.95,0-12.73C102.38,84.5,56.97,58.71,30.17,15.85c-6.13-9.8-21.71-.78-15.54,9.08h0Z"
    />
    <path
      fill="currentColor"
      d="M22.84,139.19c10.79-7.81,19.15-18.11,28.11-27.85s18.48-19.78,27.93-29.46c19.14-19.58,38.89-38.55,59.19-56.94,8.6-7.79-4.16-20.49-12.73-12.73-19.83,17.96-39.14,36.48-57.87,55.59-9.25,9.44-18.37,19.01-27.34,28.72-8.4,9.1-16.3,19.81-26.38,27.12-3.93,2.85-5.85,7.83-3.23,12.31,2.27,3.88,8.36,6.1,12.31,3.23h0Z"
    />
  </svg>
);

export default CloseIcon;
